'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AliasRewriter = function () {
    function AliasRewriter() {
        (0, _classCallCheck3.default)(this, AliasRewriter);

        this.recursiveDepth = 3;

        this.depth = 0;

        this.aliases = {};
    }

    (0, _createClass3.default)(AliasRewriter, [{
        key: 'importFromString',
        value: function importFromString(str) {
            var _this = this;

            this.aliases = {};

            str.split('\n').forEach(function (line) {
                if (line[0] !== '/') {
                    return;
                }

                var spaceSep = line.indexOf(' ');
                if (spaceSep === -1) {
                    return;
                }

                var command = line.substring(0, spaceSep);
                var actions = line.substring(spaceSep + 1).trim();
                if (!actions) {
                    return;
                }

                _this.aliases[command.toLowerCase()] = actions;
            });
        }
    }, {
        key: 'processInput',
        value: function processInput(input, vars) {
            var words = input || [];
            var alias = this.aliases[words[0].toLowerCase()];
            var aliasLen = void 0;
            var currentAliasWord = '';
            var currentAliasWordLen = 0;
            var processedConditionals = false;
            var compiled = [];

            if (!alias) return input;

            alias = alias.split(' ');
            aliasLen = alias.length;

            for (var i = 0; i < aliasLen; i++) {
                currentAliasWord = alias[i];
                currentAliasWordLen = currentAliasWord.length;

                if (!processedConditionals && currentAliasWord[0] === '$' && currentAliasWord[currentAliasWordLen - 1] === '?') {
                    var checkVar = currentAliasWord.substr(1, currentAliasWordLen - 2);
                    if (!vars[checkVar]) {
                        compiled = [];
                        break;
                    } else {
                        continue;
                    }
                } else {
                    processedConditionals = true;
                }

                if (currentAliasWord[0] !== '$') {
                    compiled.push(currentAliasWord);
                    continue;
                }

                if ((currentAliasWord[1] || '').match(/\d/)) {
                    var num = currentAliasWord.match(/\$(\d+)(\+)?(\d+)?/);

                    if (!num || !words[num[1]]) continue;

                    if (num[2] === '+' && num[3]) {
                        compiled = compiled.concat(words.slice(parseInt(num[1], 10), parseInt(num[1], 10) + parseInt(num[3], 10)));
                    } else if (num[2] === '+') {
                        compiled = compiled.concat(words.slice(parseInt(num[1], 10)));
                    } else {
                        compiled.push(words[parseInt(num[1], 10)]);
                    }

                    continue;
                }

                if (typeof vars[currentAliasWord.substr(1)] !== 'undefined') {
                    compiled.push(vars[currentAliasWord.substr(1)]);

                    continue;
                }
            }

            return compiled;
        }
    }, {
        key: 'process',
        value: function process(input, vars) {
            var line = input || '';
            var words = line.split(' ');
            var firstWord = (words[0] || '').toLowerCase();

            this.depth++;
            if (this.depth >= this.recursiveDepth) {
                this.depth--;
                return line;
            }

            if (this.aliases[firstWord]) {
                words = this.processInput(words, vars);
                firstWord = (words[0] || '').toLowerCase();

                if (this.aliases[firstWord]) {
                    words = this.process(words.join(' '), vars).split(' ');
                }
            }

            this.depth--;
            return words.join(' ');
        }
    }]);
    return AliasRewriter;
}();

exports.default = AliasRewriter;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["AliasRewriter"]
window._kiwi_exports.libs.AliasRewriter = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/AliasRewriter.js
// module id = XFo2
// module chunks = 1